module.exports = __webpack_public_path__ + "static/media/sefaz.b2e373b9.png";